"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _queries = require("../api/media/queries");
var _mobx = require("mobx");
var _ravenJs = _interopRequireDefault(require("raven-js"));
var _checklistUtils = require("../utils/checklist-utils");
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ChecklistStore = (_class = /*#__PURE__*/_createClass(function ChecklistStore(apolloClient) {
  var _this = this;
  _classCallCheck(this, ChecklistStore);
  _initializerDefineProperty(this, "checklistId", _descriptor, this);
  _initializerDefineProperty(this, "checklist", _descriptor2, this);
  _initializerDefineProperty(this, "isChecklistSubmitted", _descriptor3, this);
  _initializerDefineProperty(this, "isChecklistBeingSubmitted", _descriptor4, this);
  _initializerDefineProperty(this, "showErrorModal", _descriptor5, this);
  _initializerDefineProperty(this, "showErrorSubmittingModal", _descriptor6, this);
  _initializerDefineProperty(this, "showChecklistsDisabledModal", _descriptor7, this);
  _defineProperty(this, "setNotification", function (notification) {
    _this.notification = notification;
  });
  _initializerDefineProperty(this, "setChecklistId", _descriptor8, this);
  _initializerDefineProperty(this, "setChecklist", _descriptor9, this);
  _initializerDefineProperty(this, "setIsChecklistSubmitted", _descriptor10, this);
  _initializerDefineProperty(this, "openErrorModal", _descriptor11, this);
  _initializerDefineProperty(this, "closeErrorModal", _descriptor12, this);
  _initializerDefineProperty(this, "openErrorSubmittingModal", _descriptor13, this);
  _initializerDefineProperty(this, "closeErrorSubmittingModal", _descriptor14, this);
  _initializerDefineProperty(this, "openChecklistsDisabledModal", _descriptor15, this);
  _initializerDefineProperty(this, "closeChecklistsDisabledModal", _descriptor16, this);
  _initializerDefineProperty(this, "setIsChecklistBeingSubmitted", _descriptor17, this);
  _initializerDefineProperty(this, "updateChecklist", _descriptor18, this);
  _initializerDefineProperty(this, "resetChecklist", _descriptor19, this);
  _initializerDefineProperty(this, "submitChecklist", _descriptor20, this);
  _defineProperty(this, "setStore", function (store) {
    return _this.store = store;
  });
  _defineProperty(this, "uploadSignature", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(signatureSvg) {
      var _data$getPresignedSig, _data$getPresignedSig2;
      var _yield$_this$apolloCl, data, signatureUploadUrl, key, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.apolloClient.query({
              fetchPolicy: 'network-only',
              query: _queries.GetPresignedSignatureUrl
            });
          case 2:
            _yield$_this$apolloCl = _context.sent;
            data = _yield$_this$apolloCl.data;
            signatureUploadUrl = data === null || data === void 0 || (_data$getPresignedSig = data.getPresignedSignatureUrl) === null || _data$getPresignedSig === void 0 ? void 0 : _data$getPresignedSig.url;
            key = data === null || data === void 0 || (_data$getPresignedSig2 = data.getPresignedSignatureUrl) === null || _data$getPresignedSig2 === void 0 ? void 0 : _data$getPresignedSig2.key;
            _context.next = 8;
            return fetch(signatureUploadUrl, {
              method: 'PUT',
              body: signatureSvg,
              headers: {
                'Content-Type': 'image/svg+xml'
              }
            });
          case 8:
            response = _context.sent;
            if (response.ok) {
              _context.next = 11;
              break;
            }
            throw new Error("Error uploading signature: ".concat(response));
          case 11:
            return _context.abrupt("return", key);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "feedbackForStep", function (stepId) {
    var _this$checklist$stepI;
    return (_this$checklist$stepI = _this.checklist[stepId]) === null || _this$checklist$stepI === void 0 ? void 0 : _this$checklist$stepI.feedbackText;
  });
  _defineProperty(this, "mediaUrlForStep", function (stepId) {
    var _this$checklist$stepI2;
    return (_this$checklist$stepI2 = _this.checklist[stepId]) === null || _this$checklist$stepI2 === void 0 ? void 0 : _this$checklist$stepI2.mediaUrl;
  });
  this.apolloClient = apolloClient;
  (0, _mobx.makeObservable)(this);
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "checklistId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "checklist", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isChecklistSubmitted", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isChecklistBeingSubmitted", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showErrorModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showErrorSubmittingModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showChecklistsDisabledModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "setChecklistId", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;
    return function (checklistId) {
      return _this2.checklistId = checklistId;
    };
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "setChecklist", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function (checklist) {
      return _this3.checklist = checklist;
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "setIsChecklistSubmitted", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (isChecklistSubmitted) {
      return _this4.isChecklistSubmitted = isChecklistSubmitted;
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "openErrorModal", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;
    return function () {
      return _this5.showErrorModal = true;
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "closeErrorModal", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this6 = this;
    return function () {
      return _this6.showErrorModal = false;
    };
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "openErrorSubmittingModal", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this7 = this;
    return function () {
      return _this7.showErrorSubmittingModal = true;
    };
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "closeErrorSubmittingModal", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this8 = this;
    return function () {
      return _this8.showErrorSubmittingModal = false;
    };
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "openChecklistsDisabledModal", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this9 = this;
    return function () {
      return _this9.showChecklistsDisabledModal = true;
    };
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "closeChecklistsDisabledModal", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this10 = this;
    return function () {
      return _this10.showChecklistsDisabledModal = false;
    };
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "setIsChecklistBeingSubmitted", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this11 = this;
    return function (isChecklistBeingSubmitted) {
      return _this11.isChecklistBeingSubmitted = isChecklistBeingSubmitted;
    };
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "updateChecklist", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this12 = this;
    return function (stepId) {
      var _checklist$stepId, _checklist$stepId2, _checklist$stepId3;
      var infos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var checked = infos.checked,
        unchecked = infos.unchecked,
        feedbackText = infos.feedbackText,
        mediaUrl = infos.mediaUrl,
        optionId = infos.optionId;
      var checklist = (0, _checklistUtils.getChecklistFromLocalStorage)(_this12.checklistId);
      if ((_checklist$stepId = checklist[stepId]) !== null && _checklist$stepId !== void 0 && _checklist$stepId.checkEscalated && (checked !== checklist[stepId].checked || unchecked !== checklist[stepId].unchecked || optionId !== checklist[stepId].optionId || feedbackText !== checklist[stepId].feedbackText || mediaUrl !== checklist[stepId].mediaUrl)) {
        checklist[stepId].checkEscalated = false;
      }
      if ((_checklist$stepId2 = checklist[stepId]) !== null && _checklist$stepId2 !== void 0 && _checklist$stepId2.escalationAttemptsIds && infos.escalationAttemptsIds) {
        infos.escalationAttemptsIds = [].concat(_toConsumableArray(checklist[stepId].escalationAttemptsIds), _toConsumableArray(infos.escalationAttemptsIds));
        //Generate the HASH of the current state and store it in array
      }

      // Remove answer if the same value is clicked again - OLD CHECKLIST
      var existingCheckedValue = checklist[stepId] && checklist[stepId].checked;
      var existingUncheckedValue = checklist[stepId] && checklist[stepId].unchecked;
      if (existingCheckedValue === checked && existingUncheckedValue === unchecked) {
        infos.checked = false;
        infos.unchecked = false;
      }

      // Remove answer if the same value is clicked again - NEW CHECKLIST
      if (optionId === ((_checklist$stepId3 = checklist[stepId]) === null || _checklist$stepId3 === void 0 ? void 0 : _checklist$stepId3.optionId)) {
        infos.optionId = null;
      }
      checklist[stepId] = _objectSpread(_objectSpread({}, checklist[stepId]), infos);
      var isEmptyChecklist = Object.keys(checklist).length === 0;
      isEmptyChecklist ? (0, _checklistUtils.clearChecklistFromLocalStorage)(_this12.checklistId) : (0, _checklistUtils.saveChecklistToLocalStorage)(_this12.checklistId, checklist);
      _this12.setChecklist(checklist);
    };
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "resetChecklist", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this13 = this;
    return function () {
      if (_this13.checklistId) {
        _this13.updateChecklist({});
        (0, _checklistUtils.clearChecklistFromLocalStorage)(_this13.checklistId);
        _this13.setChecklistId();
        _this13.setIsChecklistSubmitted(false);
        _this13.setIsChecklistBeingSubmitted(false);
      }
    };
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "submitChecklist", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this14 = this;
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(fullName, signatureSvg, submitChecklistAnswerMutation, nextButton, instruction) {
        var _this14$store, _this14$store$instruc, _this14$store$instruc2, checklistId, steps, currentGuideVersionId, hasChecklistsSignatureEnabled, signatureKey, items, checklistAnswer, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this14$store = _this14.store, _this14$store$instruc = _this14$store.instructionPage, _this14$store$instruc2 = _this14$store$instruc.currentInstruction, checklistId = _this14$store$instruc2.id, steps = _this14$store$instruc2.steps, currentGuideVersionId = _this14$store$instruc.currentGuideVersionId, hasChecklistsSignatureEnabled = _this14$store.platform.hasChecklistsSignatureEnabled;
              signatureKey = '';
              _this14.setIsChecklistBeingSubmitted(true);
              items = steps.map(function (step) {
                var foundCheck = _this14.checklist[step.id];
                return foundCheck ? {
                  stepId: step.id,
                  value: _this14.checklist[step.id].checked ? true : _this14.checklist[step.id].unchecked ? false : null,
                  checklistTemplateOptionId: _this14.checklist[step.id].optionId || null,
                  feedback: _this14.checklist[step.id].feedbackText || '',
                  mediaUrl: _this14.checklist[step.id].mediaUrl || null,
                  escalationAttemptsIds: _this14.checklist[step.id].escalationAttemptsIds || []
                } : {
                  stepId: step.id,
                  value: null,
                  feedback: '',
                  mediaUrl: null,
                  escalationAttemptsIds: []
                };
              });
              checklistAnswer = {
                instructionId: checklistId,
                guideVersionId: currentGuideVersionId,
                user: fullName,
                items: items,
                signatureKey: signatureKey
              };
              _context2.prev = 5;
              if (!(hasChecklistsSignatureEnabled && instruction.requireSignature)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 9;
              return _this14.uploadSignature(signatureSvg);
            case 9:
              checklistAnswer.signatureKey = _context2.sent;
            case 10:
              _context2.next = 12;
              return submitChecklistAnswerMutation({
                checklistAnswer: checklistAnswer
              });
            case 12:
              result = _context2.sent;
              if (result.data.submitChecklistAnswer.result) {
                _context2.next = 15;
                break;
              }
              throw new Error('Checklist answers not submitted');
            case 15:
              _this14.setIsChecklistSubmitted(true);
              if (nextButton) {
                nextButton.click();
              }
              (0, _checklistUtils.clearChecklistFromLocalStorage)(checklistId);
              _this14.setChecklist({});
              _context2.next = 25;
              break;
            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](5);
              _ravenJs["default"].captureException(_context2.t0);
              _this14.openErrorSubmittingModal();
            case 25:
              _context2.prev = 25;
              _this14.setIsChecklistBeingSubmitted(false);
              return _context2.finish(25);
            case 28:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[5, 21, 25, 28]]);
      }));
      return function (_x2, _x3, _x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }();
  }
})), _class);
var _default = exports["default"] = ChecklistStore;
//# sourceMappingURL=checklist-store.js.map